import ChipSelector from '@components/ChipSelector/ChipSelector';
import useNoRenderRef from '@hooks/use-no-render-ref';
import { Stack, Text } from '@ui-lib';
import { useEffect, useState } from 'react';

interface SuggestionsSectionProps {
  options: string[];
  onSelect: (suggestion: string) => void;
  selectedOption: string | undefined;
  subject: 'label' | 'title';
}

function useSuggestionsSection(
  options: string[],
  value?: string | null,
): [string | undefined, React.Dispatch<React.SetStateAction<string | undefined>>] {
  const [selectedOption, setSelectedOption] = useState<string>();
  const optionsRef = useNoRenderRef(options);

  useEffect(() => {
    if (value && optionsRef.current.includes(value)) {
      setSelectedOption(value);
    } else setSelectedOption(undefined);
  }, [optionsRef, value]);

  return [selectedOption, setSelectedOption];
}

const SuggestionsSection: React.FC<React.PropsWithChildren<SuggestionsSectionProps>> = ({
  options,
  onSelect,
  selectedOption,
  subject,
}) => {
  return (
    <Stack gap="small">
      <Text tone="secondary" size="small">
        Here are some suggestions for your {subject}:
      </Text>
      <ChipSelector
        mode="single"
        options={options}
        onSelect={onSelect}
        selectedOption={selectedOption}
        color="subtle"
        size="medium"
      />
    </Stack>
  );
};

export default SuggestionsSection;
export { useSuggestionsSection };
